import React, { useMemo } from "react";
import styled from "styled-components";
import TdText from "../../text/table/tdText";
import PretendardText from "../../text/pretendardText";

function TableFilterManager({ style, onClick, isOpen, list, selectedValue }) {
  const selectedTitle = useMemo(() => {
    return list.find((item) => item.value === selectedValue)?.title;
  }, [list, selectedValue]);

  return (
    <div>
      <TableFilterWrapper
        style={{
          ...style,
        }}
      >
        <TdText
          style={{
            color: "#262C31",
            fontWeight: "600",
          }}
        >
          {selectedTitle}
        </TdText>
        <img
          src="/assets/admin/icons/ico_arrow_down.svg"
          alt=""
          style={{ cursor: "pointer" }}
          onClick={onClick}
        />
      </TableFilterWrapper>
      {isOpen ? (
        <SubMenuWrapper>
          {list.map((item, index) => {
            return (
              <SubMenuTextWrapper
                key={index}
                onClick={() => {
                  if (item.value === selectedValue) {
                    return;
                  }
                  item.onClick();
                }}
              >
                <SubMenuText>{item.title}</SubMenuText>
                {/* {item.value === selectedValue ? (
                  <img src="/assets/admin/icons/ico_filter_check.svg" alt="" />
                ) : (
                  ""
                )} */}
              </SubMenuTextWrapper>
            );
          })}
        </SubMenuWrapper>
      ) : (
        ""
      )}
    </div>
  );
}

export default TableFilterManager;

const TableFilterWrapper = styled.div.attrs((props) => {})`
  width: 77px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  min-width: 115px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  background: #fff;
  position: absolute;
  top: 48px;
  left: 0px;
  z-index: 2;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
`;

const SubMenuTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #f2f4f5;
  }
`;

const SubMenuText = styled(PretendardText).attrs((props) => {})`
  color: #262c31;
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
`;
